// Import team avatars
import avatar1 from '../avatars/one-man.jpg';
import avatar2 from '../avatars/two-man.jpg';
import avatar3 from '../avatars/three-boy.jpg';
import avatar4 from '../avatars/four-boy.jpg';
import avatar5 from '../avatars/five-woman.jpg';
import avatar6 from '../avatars/six-woman.jpg';
import avatar7 from '../avatars/seven-woman.jpg';
import avatar8 from '../avatars/eight-man.jpg';

// Avatar pool for teams
export const teamAvatars = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8];

// Color pool for teams
const teamColors = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal  
  '#FFD93D', // Yellow
  '#9966FF', // Purple
  '#95E77E', // Green
  '#FF9FF3', // Pink
  '#54A0FF', // Blue
  '#FFA502'  // Orange
];

// Get avatar for a team by index
export function getTeamAvatar(teamIndex) {
  return teamAvatars[teamIndex % teamAvatars.length];
}

// Get color for a team by index
export function getTeamColor(teamIndex) {
  return teamColors[teamIndex % teamColors.length];
}

// Check if a color is dark (needs white text)
export function isColorDark(color) {
  // Purple, Red, Blue need white text
  return ['#9966FF', '#FF6B6B', '#54A0FF'].includes(color);
}

// Get all available avatars
export function getAllTeamAvatars() {
  return teamAvatars;
}